export default __webpack_public_path__ + "img/799d81e0ec25c4d391632ab52fd6cacf.svg";